export interface Currency {
  name: string
  icon: any
}

export enum CurrencyEnum {
  EUR = 'EUR',
  USD = 'USD',
}
